export const images = {
  boardroom: 'https://cdn.magicpatterns.com/patterns/generated-images/06f401bc-d24a-41ae-8c5e-e0ab6e2ad912.jpg',
  leadersMeeting: 'https://cdn.magicpatterns.com/patterns/generated-images/28e04112-ee71-46bf-979e-447fe77f99aa.jpg',
  candidate: 'https://cdn.magicpatterns.com/patterns/generated-images/71e550a0-0a74-4d6d-8625-9768c0791e9a.jpg',
  executiveWindow: 'https://cdn.magicpatterns.com/patterns/generated-images/99b07069-e875-4fbf-befa-b3a8812a6417.jpg',
  architecture: 'https://cdn.magicpatterns.com/patterns/generated-images/0ce5eac7-73df-41c8-86d5-71ffb208a3c8.jpg',
};
